/**
 * Helper function to filter out streams based on `who`
 * @param {Set} streams - Telnyx's `room.getState().streams
 * @param {String(CITIZEN|ECC_USER)} who - who to filter out
 */
const filterStreams = (streams, who) => {
  if (!who) {
    return streams;
  }

  const streamsList = Array.from(streams);
  const filteredStreams = streamsList
    .map(stream => stream[1])
    .filter(stream => {
      return stream.key !== who;
    });
  return filteredStreams;
};

export default filterStreams;
